var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column align-items-center",attrs:{"data-cy":"scroll-hint"}},[_c('h5',{class:`mb-3${_vm.dark ? ' dark' : ''}`},[_vm._v("SCROLL")]),_c('Arrow',{attrs:{"direction":"down","size":"10px","theme":_vm.theme}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }